import COPY from './connect-finance-copy';

// Stripe names the weekly anchor in lowercase English.
const WEEKDAYS = {
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
};

// 1st, 2nd, 3rd, 4th … 11th, 12th, 13th … 21st. Null for anything that is
// not a day of a month, so the caller says the interval alone.
const ordinalDay = (day) => {
  if (!Number.isInteger(day) || day < 1 || day > 31) return null;
  const teens = day % 100 >= 11 && day % 100 <= 13;
  const suffix = teens ? 'th' : { 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] || 'th';
  return `${day}${suffix}`;
};

// Stripe's own words for the schedule, in the restaurant's — sourced from
// COPY so the admin support block reuses the exact same sentences instead of
// growing a second copy of them. Its own module because the balance hero and
// the admin block both need it and neither should import the other.
export const describeSchedule = (balance) => {
  const interval = balance?.scheduleInterval;
  const schedule = COPY.balance.schedule;
  if (interval === 'daily') return schedule.daily(balance?.scheduleDelayDays);
  if (interval === 'weekly') return schedule.weekly(WEEKDAYS[balance?.scheduleWeeklyAnchor]);
  if (interval === 'monthly') return schedule.monthly(ordinalDay(balance?.scheduleMonthlyAnchor));
  if (interval === 'manual') return schedule.manual;
  return schedule.unknown;
};
